import { Component, EventEmitter, Output, inject } from '@angular/core';
import { Assessment } from '$synapse/models';
import { Router } from '@angular/router';
import { CreateExamDTO } from '$synapse/dtos';
import { MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';
import {
  AssessmentSelectionComponent,
  DatePickerComponent,
} from '$synapse/core';

@Component({
  selector: 'syn-exam-creation-modal',
  templateUrl: './exam-creation-modal.component.html',
  styleUrls: ['./exam-creation-modal.component.scss'],
  imports: [SHARED_IMPORTS, AssessmentSelectionComponent, DatePickerComponent],
})
export class ExamCreationModalComponent {
  private readonly _modalDisplay =
    inject<MatDialogRef<ExamCreationModalComponent>>(MatDialogRef);
  private readonly _router = inject(Router);

  selectedAssessments: Assessment[] = [];
  candidateId: string;
  assessmentSent = false;
  send = false;
  isSubmitOk = false;
  enableDate = false;

  private _expirationDate?: Date;

  @Output()
  addExam: EventEmitter<CreateExamDTO> = new EventEmitter();

  submit(): void {
    if (this.selectedAssessments?.length) {
      this.send = true;
      this.selectedAssessments.forEach((assessment) => {
        this.addExam.emit(this._createExam(assessment));
      });
      this.addExam.complete();
      this._modalDisplay.close();
    }
    this.assessmentSent = true;
    this._router.navigate([`/candidates/${this.candidateId}`], {
      replaceUrl: true,
    });
  }

  private _createExam(assessment: Assessment): CreateExamDTO {
    let expirationDateString: string | null = null;
    if (this._expirationDate) {
      this._expirationDate.setHours(23, 59, 59);
      expirationDateString = this._expirationDate.toISOString();
    }
    return {
      assessmentId: assessment.id,
      candidateId: this.candidateId,
      expirationDate: expirationDateString,
    } as CreateExamDTO;
  }

  addAssessment(assessments: Assessment[]): void {
    this.selectedAssessments = assessments;
    this.enableDate = this.selectedAssessments.length !== 0;
    this._checkSubmit();
  }

  onNewDate(newDate: Date) {
    this._expirationDate = newDate;
    this._checkSubmit();
  }

  private _checkSubmit() {
    this.isSubmitOk = this.selectedAssessments.length !== 0;
  }
}
